import { api } from '@/api/core/api';

export const COUNT_AERIAL_MATTERS_URL = 'aerial/count-matters';

/** Counts matters for the filters saved on an existing aerial. */
export interface CountAerialMattersRequest {
  aerialId: string;
}

export interface CountAerialMattersResponse {
  count: number;
}

const countAerialMattersApi = api.injectEndpoints({
  endpoints: (builder) => ({
    countAerialMatters: builder.query<CountAerialMattersResponse, CountAerialMattersRequest>({
      query: ({ aerialId }) => ({
        url: COUNT_AERIAL_MATTERS_URL,
        method: 'GET',
        params: {
          aerialId,
        },
      }),
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

export const { useCountAerialMattersQuery } = countAerialMattersApi;
